module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web2.362ebf1a.png";